const createNewUserRed = ( state = {
    status: "init",
    formData: {},
    data: {},
    customerID: "", //todo: we may not need this
    customerSubscription: "", //todo: we may not need this either
    firstName: '',
    lastName: '',
    permission: '',
    userName: '',
    inputValidation: {validated: true},
    password: '',
}, action )=>{
    if ( action.type ===  'CREATE_NEW_USER') {
        switch (action.payload.status){
            case 'succeed':
                return Object.assign({}, state, {
                    status: action.payload.status,
                    userName: action.payload.userName
                })
            case 'failed':
                return Object.assign({}, state, {
                    status: action.payload.status,
                    userName: action.payload.userName,
                    errorMessage: action.payload.errorMessage
                })
            case 'notValid':
                return Object.assign({}, state, {
                    status: action.payload.status,
                    inputValidation: action.payload.inputValidation
                })
            case 'cancelled':
                return Object.assign({}, state, {
                    status: action.payload.status,
                    inputValidation: {validated: true}
                })
            default:
                return Object.assign({}, state, {
                    status: action.payload.status
                })
        }
    } else {
        return state;
    }
};

export default createNewUserRed;


/** WEBPACK FOOTER **
 ** ./src/reducers/createNewUserRed.js
 **/